import React from 'react';

/** Domyślny rocznik protokołów CEEB — BIEŻĄCY rok (właściciel 2026-10-02, A13). */
export const currentProtocolYear = (): string => String(new Date().getFullYear());

/**
 * Rocznik dla protokołów CEEB w paczce / komplecie (E6). '' = „wszystkie lata" (cała historia).
 * Wspólny dla „Pobierz ▾" listy budynków i kompletu w widoku budynku (B10).
 */
export function ProtocolYearSelect({ value, onChange, disabled = false }: {
  value: string; onChange: (value: string) => void; disabled?: boolean;
}) {
  return (
    <select
      aria-label="Rok protokołów CEEB"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      style={{
        minHeight: 'var(--touch-min)',
        padding: '0 var(--space-3)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-label)',
        color: 'var(--text-primary)',
        background: 'var(--surface-card)',
        border: 'var(--border-width-strong) solid var(--border-strong)',
        borderRadius: 'var(--radius-md)',
        cursor: 'pointer',
      }}
    >
      <option value="">wszystkie lata</option>
      {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i).map((y) => (
        <option key={y} value={String(y)}>{y}</option>
      ))}
    </select>
  );
}
